module.exports = __webpack_public_path__ + "static/media/A2_08.58909b7c.png";